import { render, staticRenderFns } from "./ModifyStatus.vue?vue&type=template&id=74a4edb3&scoped=true&"
import script from "./ModifyStatus.vue?vue&type=script&lang=js&"
export * from "./ModifyStatus.vue?vue&type=script&lang=js&"
import style0 from "./ModifyStatus.vue?vue&type=style&index=0&id=74a4edb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4edb3",
  null
  
)

export default component.exports